function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;


//////////////////
// WEBPACK FOOTER
// ./~/react-event-listener/~/@babel/runtime/helpers/builtin/classCallCheck.js
// module id = ./node_modules/react-event-listener/node_modules/@babel/runtime/helpers/builtin/classCallCheck.js
// module chunks = 1